module.exports = __webpack_public_path__ + "img/Number=69.dcd2a2f5.png";